import { useSession } from 'next-auth/react'
import Script from 'next/script'

const QualtricsSnippet = () => {
  const { data: sessionData } = useSession()
  const user = sessionData?.user

  if (!user) {
    return null
  }

  return (
    <>
      <Script id="qualtrics-snippet" strategy="afterInteractive">
        {`
          if (typeof QSI === "undefined") {
            QSI = {};
            QSI.config = {
              externalReference: ${JSON.stringify(user.id)}
            };
          }
          (function(){var g=function(g){
            this.go=function(){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)};
            this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
            try{(new g(${JSON.stringify(
              process.env.NEXT_PUBLIC_QUALTRICS_URL
            )})).start()}catch(i){}
          })();
        `}
      </Script>
      <div id={process.env.NEXT_PUBLIC_QUALTRICS_ZID} />
    </>
  )
}

export default QualtricsSnippet
